import { Controller } from "@hotwired/stimulus"

// The host is outside drawer content, so centering always uses the viewport.
export default class extends Controller {
  connect() {
    this.update = this.update.bind(this)
    this.queueUpdate = this.queueUpdate.bind(this)
    this.navbar = document.querySelector("[data-toast-navbar]")
    this.observer = new ResizeObserver(this.queueUpdate)
    if (this.navbar) this.observer.observe(this.navbar)
    this.observer.observe(document.body)
    this.observer.observe(this.element)
    // Drawers can remove their source containers without a Turbo render event.
    this.sourceObserver = new MutationObserver(() => this.discardDetachedSources())
    this.sourceObserver.observe(document.body, { childList: true, subtree: true })
    window.addEventListener("scroll", this.queueUpdate, { passive: true, capture: true })
    window.addEventListener("resize", this.queueUpdate)
    this.update()
  }

  disconnect() {
    this.observer.disconnect()
    this.sourceObserver.disconnect()
    window.removeEventListener("scroll", this.queueUpdate, { capture: true })
    window.removeEventListener("resize", this.queueUpdate)
    cancelAnimationFrame(this.frame)
  }

  discardDetachedSources() {
    for (const element of Array.from(this.element.children)) {
      this.application.getControllerForElementAndIdentifier(element, "toast")?.discardDetachedSource()
    }
  }

  queueUpdate() {
    if (this.frame) return
    this.frame = requestAnimationFrame(this.update)
  }

  update() {
    this.frame = null
    const bottom = this.navbar?.isConnected ? Math.max(0, this.navbar.getBoundingClientRect().bottom) : null
    this.element.style.setProperty("--toast-top", `${bottom === null ? 24 : bottom + 16}px`)
    this.element.tabIndex = this.element.scrollHeight > this.element.clientHeight ? 0 : -1
  }
}
